{
  "removeAriaLabel": "Remove"
}
